import React, { useEffect } from 'react';
import { CheckCircleIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';

const Toast = ({ isOpen, onClose, type = 'success', message, duration }) => {
    // Set default duration based on toast type
    const getDefaultDuration = () => {
        if (duration !== undefined) return duration;
        switch (type) {
            case 'error':
                return 5000; // 5 seconds for errors
            case 'warning':
                return 4000; // 4 seconds for warnings
            case 'info':
                return 3500; // 3.5 seconds for info
            case 'success':
            default:
                return 3000; // 3 seconds for success
        }
    };

    const toastDuration = getDefaultDuration();

    useEffect(() => {
        if (isOpen && toastDuration > 0) {
            const timer = setTimeout(() => {
                onClose();
            }, toastDuration);
            return () => clearTimeout(timer);
        }
    }, [isOpen, toastDuration, onClose]);

    if (!isOpen) return null;

    const getToastStyles = () => {
        switch (type) {
            case 'success':
                return 'bg-green-50 border-green-200 text-green-800';
            case 'error':
                return 'bg-red-50 border-red-200 text-red-800';
            case 'warning':
                return 'bg-yellow-50 border-yellow-200 text-yellow-800';
            case 'info':
                return 'bg-blue-50 border-blue-200 text-blue-800';
            default:
                return 'bg-gray-50 border-gray-200 text-gray-800';
        }
    };

    const getIcon = () => {
        switch (type) {
            case 'success':
                return <CheckCircleIcon className="h-5 w-5 text-green-400" />;
            case 'error':
                return <ExclamationTriangleIcon className="h-5 w-5 text-red-400" />;
            case 'warning':
                return <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" />;
            case 'info':
                return <ExclamationTriangleIcon className="h-5 w-5 text-blue-400" />;
            default:
                return <CheckCircleIcon className="h-5 w-5 text-gray-400" />;
        }
    };

    return (
        <div className="fixed top-4 right-4 z-50 max-w-sm w-full">
            <div className={`rounded-lg border p-4 shadow-lg ${getToastStyles()}`}>
                <div className="flex items-start">
                    <div className="flex-shrink-0">
                        {getIcon()}
                    </div>
                    <div className="ml-3 flex-1">
                        <p className="text-sm font-medium">
                            {message}
                        </p>
                    </div>
                    <div className="ml-4 flex-shrink-0">
                        <button
                            onClick={onClose}
                            className="inline-flex rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            <span className="sr-only">Close</span>
                            <XMarkIcon className="h-4 w-4" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Toast;























